import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron",
  "use": "chevron-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron\">\n<g opacity=\"0.5\">\n<path d=\"M6.76644 7.7418L9.99977 10.9751L13.2331 7.7418C13.5581 7.4168 14.0831 7.4168 14.4081 7.7418C14.7331 8.0668 14.7331 8.5918 14.4081 8.9168L10.5831 12.7418C10.2581 13.0668 9.73311 13.0668 9.40811 12.7418L5.58311 8.9168C5.25811 8.5918 5.25811 8.0668 5.58311 7.7418C5.90811 7.42513 6.44144 7.4168 6.76644 7.7418Z\" fill=\"#211F1D\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol